import Request from './Request';

export interface IChannelType{
    id: number;
    name: string;
    slug: string;
}

let _allCache: Promise<IChannelType[]> | null = null;

export function clearChannelTypeCache() {
    _allCache = null;
}

class ChannelType {
    static GetAll = (): Promise<IChannelType[]> => {
        if (!_allCache) {
            _allCache = Request.DoGet('channelType/all') as unknown as Promise<IChannelType[]>;
            _allCache.catch(() => { _allCache = null; });
        }
        return _allCache;
    };
}

export default ChannelType;